import React from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useIntl } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import LoadingButton from '@atlaskit/button/loading-button';
import { ANALYTICS_CHANNEL, LINK_CREATE_FORM_POST_CREATE_FIELD } from '../../../../common/constants';
import createEventPayload from '../../../../common/utils/analytics/analytics.codegen';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { FormSpy } from '../../form-spy';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { messages } from '../messages';
export var SubmitButton = function SubmitButton() {
  var intl = useIntl();
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useFormState = useFormState(),
    submitting = _useFormState.submitting;
  var _useForm = useForm(),
    mutators = _useForm.mutators;
  return /*#__PURE__*/React.createElement(FormSpy, null, function (_ref) {
    var values = _ref.values;
    return /*#__PURE__*/React.createElement(LoadingButton, {
      type: "submit",
      appearance: "primary",
      isLoading:
      /**
       * Should only be in a loading state if submitting is because we clicked
       * the submit button
       */
      submitting && values[LINK_CREATE_FORM_POST_CREATE_FIELD] === false,
      testId: "link-create-form-button-submit",
      onClick: function onClick() {
        var _mutators$setField;
        createAnalyticsEvent(createEventPayload('ui.button.clicked.create', {})).fire(ANALYTICS_CHANNEL);
        (_mutators$setField = mutators.setField) === null || _mutators$setField === void 0 || _mutators$setField.call(mutators, LINK_CREATE_FORM_POST_CREATE_FIELD, false);
      }
    }, intl.formatMessage(messages.create));
  });
};